/* eslint-disable no-unused-vars */
/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import theme from "assets/theme";
import { ThemeProvider } from "@emotion/react";
// Material Dashboard 2 PRO React Context Provider
import { MaterialUIControllerProvider } from "context";
import PrivateRoute from "PrivateRoute";
import { Provider } from "react-redux";
import { ProvideAuthFaibrik } from "context/ProvideAuthFaibrik";
import GloabAppSettingsComponent from "pages/settings";
import { createRoot } from "react-dom/client";
import store from "redux-react/store";
import { Auth0Provider } from "./react-auth0-wrapper";
import config from "./auth_config.json";

const onRedirectCallback = appState => {
	window.history.replaceState(
		{},
		document.title,
		appState && appState.targetUrl ? appState.targetUrl : window.location.pathname
	);
};

const root = createRoot(document.getElementById("root"));

root.render(
	<Auth0Provider
		domain={config.domain}
		client_id={config.clientId}
		redirect_uri={config.redirect_uri}
		audience={config.audience}
		onRedirectCallback={onRedirectCallback}
	>
		<Provider store={store}>
			<ProvideAuthFaibrik>
				<ThemeProvider theme={theme}>
					<Suspense fallback={<div className="loading"></div>}>
						<BrowserRouter>
							<MaterialUIControllerProvider>
								<GloabAppSettingsComponent>
									<PrivateRoute path="/" component={App} />
								</GloabAppSettingsComponent>
							</MaterialUIControllerProvider>
						</BrowserRouter>
					</Suspense>
				</ThemeProvider>
			</ProvideAuthFaibrik>
		</Provider>
	</Auth0Provider>
);
